"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaTypesNumerable = exports.ScoreTypesNumerable = exports.MetaTypes = exports.ScoreTypes = exports.TimePeriodVariants = exports.PollingTrigger = exports.Routes = exports.PageType = exports.PollerName = exports.ActionTypeSuffix = exports.AsyncBetStatus = exports.CompleteBetStatus = exports.EntityNames = exports.OddUpdateStatus = exports.BetslipStatus = exports.MatchListView = exports.OddFormat = exports.OddStatisticView = exports.FetchStatus = void 0;
var constants_1 = require("@gin-betting/constants");
Object.defineProperty(exports, "FetchStatus", { enumerable: true, get: function () { return constants_1.FetchStatus; } });
var OddStatisticView;
(function (OddStatisticView) {
    OddStatisticView["MATCH"] = "match";
    OddStatisticView["MARKET"] = "market";
})(OddStatisticView = exports.OddStatisticView || (exports.OddStatisticView = {}));
var OddFormat;
(function (OddFormat) {
    OddFormat["Decimal"] = "Decimal";
    OddFormat["Fractional"] = "Fractional";
    OddFormat["US"] = "US";
    OddFormat["HongKong"] = "HongKong";
    OddFormat["Indo"] = "Indo";
    OddFormat["Malay"] = "Malay";
})(OddFormat = exports.OddFormat || (exports.OddFormat = {}));
var MatchListView;
(function (MatchListView) {
    MatchListView["table"] = "table";
    MatchListView["rows"] = "rows";
})(MatchListView = exports.MatchListView || (exports.MatchListView = {}));
var BetslipStatus;
(function (BetslipStatus) {
    BetslipStatus["INITIAL"] = "INITIAL";
    BetslipStatus["PROCESSING"] = "PROCESSING";
    BetslipStatus["ERROR"] = "ERROR";
    BetslipStatus["SUCCESS"] = "SUCCESS";
})(BetslipStatus = exports.BetslipStatus || (exports.BetslipStatus = {}));
var OddUpdateStatus;
(function (OddUpdateStatus) {
    OddUpdateStatus["acceptAll"] = "acceptAll";
    OddUpdateStatus["acceptHigher"] = "acceptHigher";
    OddUpdateStatus["alwaysAsk"] = "alwaysAsk";
})(OddUpdateStatus = exports.OddUpdateStatus || (exports.OddUpdateStatus = {}));
var EntityNames;
(function (EntityNames) {
    EntityNames["Markets"] = "markets";
    EntityNames["Odds"] = "odds";
    EntityNames["Matches"] = "matches";
    EntityNames["Match"] = "match";
    EntityNames["Tournaments"] = "tournaments";
    EntityNames["Competitors"] = "competitors";
    EntityNames["Slugs"] = "slugs";
    EntityNames["Sports"] = "sports";
    EntityNames["Bets"] = "bets";
    EntityNames["BetOdds"] = "betOdds";
    EntityNames["Streams"] = "streams";
    EntityNames["Players"] = "players";
    EntityNames["Teams"] = "teams";
    EntityNames["MarketTemplates"] = "marketTemplates";
    EntityNames["Freebets"] = "freebets";
    EntityNames["FreezedOdds"] = "freezedOdds";
    EntityNames["OddsStatisticBets"] = "oddsStatisticBets";
    EntityNames["BiddingMarkets"] = "oddsStatisticMarkets";
    EntityNames["OddsStatistics"] = "oddsStatistic";
    EntityNames["Scores"] = "scores";
    EntityNames["Meta"] = "meta";
    EntityNames["CashOutOrders"] = "cashOutOrders";
    EntityNames["CashOutOrder"] = "cashOutOrder";
})(EntityNames = exports.EntityNames || (exports.EntityNames = {}));
var CompleteBetStatus;
(function (CompleteBetStatus) {
    CompleteBetStatus["INIT"] = "INIT";
    CompleteBetStatus["CREATED"] = "CREATED";
    CompleteBetStatus["PLACED"] = "PLACED";
    CompleteBetStatus["PLACE_ERROR"] = "PLACE_ERROR";
    CompleteBetStatus["ARBITRAGE_ACCEPTED"] = "ARBITRAGE_ACCEPTED";
    CompleteBetStatus["ARBITRAGE_DECLINED"] = "ARBITRAGE_DECLINED";
    CompleteBetStatus["ACCEPTED"] = "ACCEPTED";
    CompleteBetStatus["DECLINED"] = "DECLINED";
    CompleteBetStatus["SETTLED"] = "SETTLED";
    CompleteBetStatus["UNSETTLED"] = "UNSETTLED";
    CompleteBetStatus["ROLLED_BACK"] = "ROLLED_BACK";
    CompleteBetStatus["FORCED_DECLINED"] = "FORCED_DECLINED";
})(CompleteBetStatus = exports.CompleteBetStatus || (exports.CompleteBetStatus = {}));
var AsyncBetStatus;
(function (AsyncBetStatus) {
    AsyncBetStatus[AsyncBetStatus["INIT"] = 0] = "INIT";
    AsyncBetStatus[AsyncBetStatus["CREATED"] = 1] = "CREATED";
    AsyncBetStatus[AsyncBetStatus["PLACED"] = 2] = "PLACED";
    AsyncBetStatus[AsyncBetStatus["PLACE_ERROR"] = 3] = "PLACE_ERROR";
    AsyncBetStatus[AsyncBetStatus["ARBITRAGE_ACCEPTED"] = 4] = "ARBITRAGE_ACCEPTED";
    AsyncBetStatus[AsyncBetStatus["ARBITRAGE_DECLINED"] = 5] = "ARBITRAGE_DECLINED";
    AsyncBetStatus[AsyncBetStatus["ACCEPTED"] = 6] = "ACCEPTED";
    AsyncBetStatus[AsyncBetStatus["DECLINED"] = 7] = "DECLINED";
    AsyncBetStatus[AsyncBetStatus["SETTLED"] = 8] = "SETTLED";
    AsyncBetStatus[AsyncBetStatus["UNSETTLED"] = 9] = "UNSETTLED";
    AsyncBetStatus[AsyncBetStatus["ROLLED_BACK"] = 10] = "ROLLED_BACK";
})(AsyncBetStatus = exports.AsyncBetStatus || (exports.AsyncBetStatus = {}));
var ActionTypeSuffix;
(function (ActionTypeSuffix) {
    ActionTypeSuffix["REQUEST"] = "REQUEST";
    ActionTypeSuffix["SUCCESS"] = "SUCCESS";
    ActionTypeSuffix["FAIL"] = "FAIL";
})(ActionTypeSuffix = exports.ActionTypeSuffix || (exports.ActionTypeSuffix = {}));
var PollerName;
(function (PollerName) {
    PollerName["LiveMatchesViewer"] = "liveMatchesViewer";
    PollerName["Categorizer"] = "categorizer";
    PollerName["Live"] = "live";
    PollerName["Upcoming"] = "upcoming";
    PollerName["Outrights"] = "outrights";
    PollerName["Results"] = "results";
    PollerName["Tournament"] = "tournament";
    PollerName["Prematch"] = "prematch";
    PollerName["FeaturedTournaments"] = "featuredTournaments";
})(PollerName = exports.PollerName || (exports.PollerName = {}));
var PageType;
(function (PageType) {
    PageType["INNER"] = "inner";
    PageType["LIST"] = "list";
})(PageType = exports.PageType || (exports.PageType = {}));
var Routes;
(function (Routes) {
    Routes["UPCOMING_LIST"] = "/";
    Routes["RESULTS_LIST"] = "/results";
    Routes["OUTRIGHTS_LIST"] = "/outrights";
    Routes["LIVE_LIST"] = "/live";
    Routes["OUTRIGHT"] = "/outright/";
    Routes["RESULT_MATCH"] = "/result/";
    Routes["MATCH"] = "/match/";
    Routes["TOURNAMENT"] = "/tournament/";
    Routes["AFTERMATCH"] = "/aftermatch/";
    Routes["PREMATCH"] = "/next-to-go";
    Routes["ESPORT"] = "/esports";
    Routes["CLASSIC"] = "/sports";
})(Routes = exports.Routes || (exports.Routes = {}));
var PollingTrigger;
(function (PollingTrigger) {
    PollingTrigger["Reschedule"] = "Reschedule";
    PollingTrigger["Stop"] = "Stop";
})(PollingTrigger = exports.PollingTrigger || (exports.PollingTrigger = {}));
var TimePeriodVariants;
(function (TimePeriodVariants) {
    TimePeriodVariants["ONE_HOUR"] = "1hour";
    TimePeriodVariants["TODAY"] = "today";
    TimePeriodVariants["YESTERDAY"] = "yesterday";
    TimePeriodVariants["THREE_DAYS"] = "3days";
    TimePeriodVariants["WEEK"] = "week";
})(TimePeriodVariants = exports.TimePeriodVariants || (exports.TimePeriodVariants = {}));
var ScoreTypes;
(function (ScoreTypes) {
    ScoreTypes["TYPE_TOTAL"] = "total";
    ScoreTypes["TYPE_GAME_POINTS"] = "game_points";
    ScoreTypes["TYPE_SET"] = "set";
    ScoreTypes["TYPE_TIE_BREAK"] = "tie_break";
    ScoreTypes["TYPE_GOLDEN_SET"] = "golden_set";
    ScoreTypes["TYPE_YELLOW_CARD"] = "yellow_card";
    ScoreTypes["TYPE_RED_CARD"] = "red_card";
    ScoreTypes["TYPE_YELLOW_RED_CARD"] = "yellow_red_card";
    ScoreTypes["TYPE_PERIOD_1ST_HALF"] = "period_1st_half";
    ScoreTypes["TYPE_PERIOD_1ST_EXTRA"] = "period_1st_extra";
    ScoreTypes["TYPE_PERIOD_2ND_HALF"] = "period_2nd_half";
    ScoreTypes["TYPE_PERIOD_2ND_EXTRA"] = "period_2nd_extra";
    ScoreTypes["TYPE_PERIOD_PENALTIES"] = "period_penalties";
    ScoreTypes["TYPE_QUARTER"] = "quarter";
    ScoreTypes["TYPE_QUARTER_OVERTIME"] = "quarter_overtime";
    ScoreTypes["TYPE_PERIOD_REGULAR"] = "period_regular";
    ScoreTypes["TYPE_PERIOD_OVERTIME"] = "period_overtime";
    ScoreTypes["TYPE_PERIOD_BULLETS"] = "period_bullets";
    ScoreTypes["TYPE_GAME_KILLS"] = "game_kills";
    ScoreTypes["TYPE_GAME_PLAYERS"] = "game_players";
    ScoreTypes["TYPE_MAP"] = "map";
    ScoreTypes["TYPE_ROUND_OVERTIME"] = "round_overtime";
    ScoreTypes["TYPE_INNING_POINTS"] = "inning_points";
    ScoreTypes["TYPE_INNING_OUTS"] = "inning_outs";
})(ScoreTypes = exports.ScoreTypes || (exports.ScoreTypes = {}));
var MetaTypes;
(function (MetaTypes) {
    MetaTypes["TYPE_MAP"] = "map";
    MetaTypes["TYPE_SERVER"] = "server";
    MetaTypes["TYPE_SET"] = "set";
    MetaTypes["TYPE_INNING"] = "inning";
    MetaTypes["TYPE_HALF"] = "half";
    MetaTypes["TYPE_TEAM"] = "team";
    MetaTypes["TYPE_QUARTER"] = "quarter";
    MetaTypes["TYPE_OVERTIME"] = "overtime";
    MetaTypes["TYPE_TIME"] = "time";
    MetaTypes["TYPE_PERIOD"] = "period";
    MetaTypes["TYPE_BULLETS"] = "bullets";
    MetaTypes["TYPE_GAME"] = "game";
    MetaTypes["TYPE_PERIOD_NUMBER"] = "period_number";
    MetaTypes["TYPE_PERIOD_REGULAR"] = "period_regular";
    MetaTypes["TYPE_GAME_STATE"] = "game_state";
    MetaTypes["TYPE_STATE_NUMBER"] = "state_number";
    MetaTypes["TYPE_REGULAR"] = "regular";
    MetaTypes["TYPE_GOLDEN_SET"] = "golden_set";
    MetaTypes["TYPE_PERIOD_1ST_HALF"] = "period_1st_half";
    MetaTypes["TYPE_PERIOD_1ST_EXTRA"] = "period_1st_extra";
    MetaTypes["TYPE_PERIOD_2ND_HALF"] = "period_2nd_half";
    MetaTypes["TYPE_PERIOD_2ND_EXTRA"] = "period_2nd_extra";
    MetaTypes["TYPE_PERIOD_PENALTIES"] = "period_penalties";
})(MetaTypes = exports.MetaTypes || (exports.MetaTypes = {}));
exports.ScoreTypesNumerable = [
    ScoreTypes.TYPE_SET,
    ScoreTypes.TYPE_QUARTER,
    ScoreTypes.TYPE_QUARTER_OVERTIME,
    ScoreTypes.TYPE_PERIOD_REGULAR,
    ScoreTypes.TYPE_PERIOD_OVERTIME,
    ScoreTypes.TYPE_PERIOD_BULLETS,
    ScoreTypes.TYPE_GAME_KILLS,
    ScoreTypes.TYPE_GAME_PLAYERS,
    ScoreTypes.TYPE_MAP,
    ScoreTypes.TYPE_ROUND_OVERTIME,
    ScoreTypes.TYPE_INNING_POINTS,
    ScoreTypes.TYPE_INNING_OUTS,
];
exports.MetaTypesNumerable = [
    MetaTypes.TYPE_MAP,
    MetaTypes.TYPE_SET,
    MetaTypes.TYPE_PERIOD,
    MetaTypes.TYPE_REGULAR,
    MetaTypes.TYPE_QUARTER,
    MetaTypes.TYPE_OVERTIME,
    MetaTypes.TYPE_BULLETS,
    MetaTypes.TYPE_PERIOD_REGULAR,
    MetaTypes.TYPE_INNING,
];
//# sourceMappingURL=app.js.map